(function () {
  'use strict';

  function wireSwatchHover() {
    var cards = document.querySelectorAll('.uninspired-col-card');
    cards.forEach(function (card) {
      var primary = card.querySelector('.uninspired-col-card-img__primary');
      if (!primary) return;
      var originalSrc = primary.getAttribute('src');
      var originalSrcset = primary.getAttribute('srcset');
      var originalSizes = primary.getAttribute('sizes');

      card.querySelectorAll('[data-swatch-image]').forEach(function (dot) {
        var previewUrl = dot.getAttribute('data-swatch-image');
        if (!previewUrl) return;
        dot.addEventListener('mouseenter', function () {
          primary.setAttribute('src', previewUrl);
          primary.removeAttribute('srcset');
        });
        dot.addEventListener('mouseleave', function () {
          if (originalSrc) primary.setAttribute('src', originalSrc);
          if (originalSrcset) primary.setAttribute('srcset', originalSrcset);
          if (originalSizes) primary.setAttribute('sizes', originalSizes);
        });
      });
    });
  }

  function init() {
    wireSwatchHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.type && e.detail.type.indexOf('uninspired-collection') === 0) {
      init();
    }
  });
})();
